//域名统一管理
const base = {
  //url: 'http://47.104.131.194:9501',

	//url: 'http://47.104.131.194:9502',
	url: 'https://pile2.allynav.cn/v2',

}
export default base



// WEBPACK FOOTER //
// ./src/utils/base.js